import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { map, each, values, max, reduce, find } from 'lodash';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import accounting from 'accounting';
import ReactHighcharts from 'react-highcharts';
import ExcelJS from 'exceljs';
import {
  Button, Modal,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import ReactResizeDetector from 'react-resize-detector';
import {
  checkQualified,
} from '../../../Dashboard/DashboardActions';
import ProgressBar from '../../../../components/progress-bar';

import { 
  getProgressLoadPercentage,
  getProgressStats,
} from '../../../Dashboard/DashboardReducer';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';
import styles from './styles.css';
import ProgressSummary from '../progress-summary';

const STATS = [
  { key: 'notSubmitted/noQualifiedContacts', title: 'No Qualified Contacts(s)', color: '#173E65' },
  { key: 'notSubmitted/preventedByCollectorSettings', title: 'Prevented by Collector Settings', color: '#3266A1' },
  { key: 'notSubmitted/failedProductConditions', title: 'Failed Product Conditions', color: '#86ACD3' },
  { key: 'notSubmitted/invalidOwners', title: 'Invalid Owner', color: '#C6DFF8' },
  { key: 'notSubmitted/invalidSenders', title: 'Invalid Sender', color: '#d7e9fa' },
  { key: 'notSubmitted/invalidAccounts', title: 'Invalid Account', color: '#e8f2fc' },
  { key: 'notSubmitted/others', title: 'Others', color: '#848484' },
];
class ProgressStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      error: null,
      showOverviewModal: false,
      showQualifiedModal: false,
      maxHeight: 0,
      heights: {},
      id: shortid.generate(),
    };


    this.showOverviewModal = this.showOverviewModal.bind(this);
    this.hideOverviewModal = this.hideOverviewModal.bind(this);
    this.showQualifiedModal = this.showQualifiedModal.bind(this);
    this.hideQualifiedModal = this.hideQualifiedModal.bind(this);
    this.onResizeQualifiedContainer = this.onResizeQualifiedContainer.bind(this);
    this.onResizeOverviewContainer = this.onResizeOverviewContainer.bind(this);
    this.afterRender = this.afterRender.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  showOverviewModal(e) {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    this.setState({ showOverviewModal: true });
  }

  onResizeQualifiedContainer(width, height) {
    this.handleCellHeightChange('qualified', height);
  }

  onResizeOverviewContainer(width, height) {
    this.handleCellHeightChange('overview', height);
  }

  handleCellHeightChange(type, height) {
    const { heights } = this.state;
    const newHeights = {
      ...heights,
      [type]: Math.ceil(height),
    };
    const maxHeight = max(values(newHeights));
    this.setState({
      heights: newHeights,
      maxHeight,
    });
  }

  afterRender(chart) {
    // chart.setSize(chart.plotSizeX, chart.plotSizeX * .6);
  }

  hideOverviewModal() {
    this.setState({ showOverviewModal: false });
  }

  exportExcel() {
    const { progressStats } = this.props;
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'TruSales';
    workbook.created = new Date();
    workbook.modified = new Date();
    const worksheet = workbook.addWorksheet('Qualified, But Not Submitted');
    
    worksheet.columns = [
      { header: 'Reasons', key: 'reason', width: 50 },
      { header: 'Count', key: 'count', width: 20 },
      { header: 'Percentage', key: 'percentage', width: 20 },
    ];

    const totalStats = progressStats.notSubmitted || {};
    const total = totalStats?.count || 0;

    each(STATS, (stat) => {
      const s = progressStats[stat.key];
      const { count } = s;
      if (count > 0) {
        const reason = stat.title;
        const count = s.count;
        const percentage = total !== 0 ? (count / total) * 100 : 0;
        worksheet.addRow({ reason, count, percentage });
      }
    });

    workbook.xlsx.writeBuffer()
      .then(
        (data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = 'progress-dashboard-stats.xlsx';
          a.click();
          window.URL.revokeObjectURL(url);          
          document.body.removeChild(a);
        },
      );

  }

  showQualifiedModal(e) {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    this.setState({ showQualifiedModal: true });
  }

  hideQualifiedModal() {
    this.setState({ showQualifiedModal: false });
  }


  isLoading() {
    const { loadPercentage } = this.props;
    return loadPercentage > 0 && loadPercentage < 1;
  }
  
  isLoaded() {
    const { loadPercentage } = this.props;
    return loadPercentage === 1;
  }

  isAccount() {
    return this.props.automation.source === 'account';
  }

  loadData() {
    this.setState({ loading: true, loaded: false, error: null }, () => {
      const { automation, resources, dateAnchor } = this.props;
      const isAccount = this.isAccount();
      // const ids = map(resources, isAccount ? 'account_id' : 'opportunity_id');
      const ids = map(resources, 'opportunity_id'); // post with opp id
      const { userPreferences } = this.context;
      const revenueMin = userPreferences[ProgressSummary.ANNUAL_REVENUE_MIN];
      const revenueMax = userPreferences[ProgressSummary.ANNUAL_REVENUE_MAX];
      this.props.dispatch(checkQualified(this.state.id, automation._id, ids, isAccount, revenueMin, revenueMax, dateAnchor))
        .then(
          () => {
            this.setState({ loading: false, loaded: true });
          },
          (err) => {
            this.setState({ loading: false, loaded: false, error: err.data ? err.data.message : err.message });
          },
        );
    });
  }

  renderPercentage() {
    const { loadPercentage } = this.props;
    const percentage = loadPercentage * 100;
    return (
      <span className={`text-muted animated ${loadPercentage === 1 ? 'fadeOut' : 'flash infinite'}`}>
        {percentage < 100 &&
          <span>
            <Fa name="spinner" spin />
            {' '}
            <Counter value={percentage}>
              <NumberDisplay value={percentage} suffix="%" precision={percentage === '100' ? 0 : 1} />
            </Counter>
          </span>
        }
      </span>
    );
  }


  renderStats(title, stats, large = false) {
    const isLoading = this.isLoading();

    const count = stats.count || 0;
    const counter = (
      <strong>
        <Counter value={count}>
          <NumberDisplay value={count} precision={0} />
        </Counter>
      </strong>
    );

    const counterComp = this.renderCickable(stats, counter);

    return (
      <div className="text-center">
        {large && <h3 style={{ margin: 0 }}>{counterComp}</h3>}
        {!large && <div>{counterComp}</div>}
        <div><small>{this.renderCickable(stats, title)}</small></div>
      </div>
    );
  }


  renderNumberStats___OLD_VERSION() {
    const { progressStats } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-xs-6">{this.renderStats('Qualified', progressStats.qualified, true)}</div>
          <div className="col-xs-6">{this.renderStats('Submitted', progressStats.submitted, true)}</div>
        </div>
        < hr />
        <div className="row">
          <div className="col-xs-4">{this.renderStats('Excluded', progressStats.excluded)}</div>
          <div className="col-xs-4">{this.renderStats(<span>Not&nbsp;Submitted</span>, progressStats.notSubmitted)}</div>
          <div className="col-xs-4">{this.renderStats(<span>Not&nbsp;Qualified</span>, progressStats.notQualified)}</div>
        </div>
      </div>
    );
  }


  renderStatsRow(k, isMain = false) {
    const { progressStats } = this.props;
    const stats = progressStats[k] || {};

    const statSettings = k === 'qualified' ? {
      title: 'QUALIFIED',
      color: '#0C71C1',
    } : (find(ProgressSummary.STATS, { key: k }) || {});
    
    const { title, color } = statSettings;
    const count = stats.count || 0;
    let counter = (
      <Counter value={count}>
        <NumberDisplay value={count} precision={0} />
      </Counter>
    );

    if (isMain) {
      counter = (<strong>{counter}</strong>);
    }

    const counterComp = this.renderCickable(stats, counter);
    let titleComp = this.renderCickable(stats, title);
    if (isMain) {
      titleComp = (<strong>{titleComp}</strong>);
    }
    let percentage = 0;
    const totalOpportunities = isMain ? progressStats.all?.count : progressStats.qualified?.count;

    if (totalOpportunities) {
      const per = (count / totalOpportunities) * 100;
      percentage = (
        <Counter value={per}>
          <NumberDisplay value={per} precision={(per >= 100 || per === 0) ? 0 : 2} suffix="%" />
        </Counter>
      );
    }

    return (
      <tr>
        {!isMain && <td width="20" style={{ border: 'none' }}>&nbsp;</td>}
        <td colSpan={isMain ? '2' : '1'}>
          <Fa name="stop" style={{ color }} /> {titleComp}
        </td>
        <td className="text-right" width="20">{counterComp}</td>
        <td className="text-right text-muted" width="20">({percentage})</td>
      </tr>
    );
  }


  renderChart() {
    const { progressStats, automation } = this.props;
    const isEmpty = automation.is_empty === true;
    const total = progressStats.all; // total stats

    const qualified = progressStats.qualified;
    const notQualified = progressStats.notQualified;

    const isAccount = this.isAccount();

    const series1 = [
      ...(isEmpty ? [] : [
        {
          name: 'Qualified',
          color: '#0C71C1',
          y: qualified?.count, 
          opportunityIds: qualified?.ids,
          select: false,
          customData: qualified?.count,
          events: {
            click: (event) => {
              this.props.showStats(event.point.options.opportunityIds);
            },
          },
        },
      ]),
      {
        name: 'Not Qualified',
        color: '#CCCCCC',
        y:  notQualified?.count, 
        opportunityIds: notQualified?.ids,
        customData: notQualified?.count,
        select: false,
        events: {
          click: (event) => {
            this.props.showStats(event.point.options.opportunityIds);
          },
        },
      },
    ];

    const series2 = reduce(['submitted', 'notSubmitted', 'excluded'], (items, k) => {
      const s = find(ProgressSummary.STATS, { key: k }) || {};
      items.push({
        color: s.color,
        name: s?.title || k,
        // y: qualified.count ? progressStats[k]?.count / qualified.count : 0,
        y: progressStats[k]?.count,
        opportunityIds: progressStats[k]?.ids,
        select: false,
        customData: progressStats[k]?.count,
        percentageTotal: qualified.count ? (progressStats[k]?.count / qualified.count) * 100 : 0,
        events: {
          click: (event) => {
            this.props.showStats(event.point.options.opportunityIds);
          },
        },
      });
      return items;
    }, []);



    const config = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        margin: 0,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter: function format() {
          const percentage = accounting.formatNumber(this.point.percentageTotal, 2);
          const k = this.key;
          const amount = `${accounting.formatNumber(this.point.customData, 0)} ${pluralize(isAccount ? 'account' : 'opportunity', this.point.customData)}`;
          return `<div><p>${k}</p><b>${amount}</b> (${percentage}%)</div>`;
        },

        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderColor: 'rgba(0, 0, 0, 0.25)',
        useHTML: true,
        style: {
          color: 'rgba(100, 100, 100, 0.75)',
          fontSize: '12px',
        },
      },
      title: {
        text: accounting.formatNumber(total.count, 0),
        verticalAlign: 'middle',
        y: 40,
        style: {
          color: '#333333',
          fontSize: '32px',
          fontWeight: '700',
        },
      },
      subtitle: {
        text: pluralize(isAccount ? 'Account' : 'Opportunity', total.count),
        verticalAlign: 'middle',
        y: 60,
        style: {
          color: 'rgba(0, 0, 0, 0.75)',
          fontSize: '14px',
        },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
          },
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '75%'],
          size: '100%'
        }
      },
      series: [
        {
          type: 'pie',
          name: 'Total',
          innerSize: '80%',
          allowPointSelect: true,
          cursor: 'pointer',
          // size: '100%',
          // enableMouseTracking: false,

          data: [
            ...series1,
          ]
        },
        {
          type: 'pie',
          name: 'Qualified',
          size: '80%',
          innerSize: '75%',
          allowPointSelect: true,
          cursor: 'pointer',
          // enableMouseTracking: false,
          data: series2,
        },
      ],
    };
    return (
      <div className={styles.halfDonut}>
        <div className={styles.graph}>
          <ReactHighcharts config={config} ref="summary-chart" callback={this.afterRender} />
        </div>
      </div>
    );
  }

  renderOverviewStats() {
    const { maxHeight } = this.state;
    const { progressStats, automation } = this.props;
    const isAccount = this.isAccount();
    const isEmpty = automation.is_empty === true;

    const left = this.renderChart();
    const right = (
      <table className="table table-condensed" style={{ margin: 0 }}>
        <tbody>
          {!isEmpty && this.renderStatsRow('qualified', true)}
          {this.renderStatsRow('submitted')}
          {this.renderStatsRow('notSubmitted')}
          {this.renderStatsRow('excluded')}
        </tbody>
      </table>
    );

    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <div className="panel-title">
            <div className="clearfix">
              <div className="pull-left">{isAccount ? 'Accounts' : 'Opportunities'} <a href="" onClick={this.showOverviewModal}><Fa className="text-active" name="info-circle" /></a></div>
              <div className="pull-right text-right" style={{ width: '100px' }}>
                {this.renderPercentage()}
              </div>
            </div>
          </div>
        </div>
        <div className="panel-body">
          {isEmpty &&
            <div className="row">
              <div className="col-md-4 col-lg-4">
                {left}
              </div>
              <div className="col-md-8 col-lg-8">
                {right}
              </div>
            </div>
          }
          {!isEmpty &&
            <div>
              <ReactResizeDetector handleHeight handleWidth onResize={this.onResizeOverviewContainer} />
              <div style={{ minHeight: maxHeight }}>
                {left}
                {right}
              </div>
            </div>
          }
        </div>
      </div>
    );
  }


  renderCickable(stats, innerComp) {
    const isLoading = this.isLoading();
    if (isLoading || stats.count === 0 || !stats.count) {
      return innerComp;
    }
    const handler = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.props.showStats(stats.ids);
    };
    return (
      <a href="" onClick={handler}>{innerComp}</a>
    );
  }

  renderRow(title, stats, k, color) {
    const { progressStats } = this.props;

    const totalStats = progressStats.notSubmitted || {};
    const total = totalStats.count || 0;
    const count = stats && stats.count ? stats.count : 0;
    // if (count === 0 || !count) {
      // return null;
    // }
    const percentage = total !== 0 ? (count / total) * 100 : 0;

    let titleComp = title;
    let counterComp = (
      <Counter value={count}>
        <NumberDisplay value={count} precision={0} />
      </Counter>
    );
    let percentageComp = percentage === 0 ? '0%' : (
      <Counter value={percentage}>
        <NumberDisplay value={percentage} suffix="%" precision={2} />
      </Counter>
    );


    return (
      <tr key={k}>
        <td align="center" width="20" style={{ color }}><Fa name="square" /></td>
        <th>{this.renderCickable(stats, titleComp)}</th>
        <td width="100" className="text-right">{this.renderCickable(stats, counterComp)}</td>
        <td width="100" className="text-right">{percentageComp}</td>
      </tr>
    );
  }

  renderGraph() {
    const { progressStats } = this.props;
    const isAccount = this.isAccount();
    const data = [];
    let total = 0;
    each(progressStats, (progressStat, k) => {
      const st = find(STATS, { key: k });
      if (st) {
        total += progressStat.count;
        data.push({
          name: st?.title || k,
          y: progressStat.count,
          color: st?.color,
          // amount: stat.amount,
          // total: stat.total,
          opportunityIds: progressStat.ids,
          select: false,
          events: {
            click: (event) => {
              this.props.showStats(event.point.options.opportunityIds);
            },
          },
        });
      }
    });

    const config = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        type: 'pie',
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter: function format() {
          const percentage = accounting.formatNumber(this.percentage, 2);
          const k = this.key;
          const c = accounting.formatNumber(this.y, 0);
          const amount = `${accounting.formatNumber(c, 0)} ${pluralize(isAccount ? 'account' : 'opportunity', this.y)}`;
          return `<div><p>${k}</p><b>${amount}</b> (${percentage}%)</div>`;
        },

        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderColor: 'rgba(0, 0, 0, 0.25)',
        useHTML: true,
        style: {
          color: 'rgba(100, 100, 100, 0.75)',
          fontSize: '12px',
        },
      },
      title: total === 0 ? false : {
        text: `${accounting.formatNumber(total, 0)}`,
        verticalAlign: 'middle',
        y: 5,
        style: {
          color: '#333333',
          fontSize: '32px',
          fontWeight: '700',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          shadow: false,
          borderWidth: 0,
          animation: false,
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: [
        {
          name: 'Qualified, but not submitted',
          colorByPoint: true,
          innerSize: '90%',
          data,
        },
      ],
    };
    return (
      <ReactHighcharts config={config} ref="progress-chart" />
    );
  }

  renderDownloadButton() {
    const isLoading = this.isLoading();
    if (isLoading) {
      return null;
    }
    return (
      <Button bsStyle="link" onClick={this.exportExcel}><Fa name="download" /></Button>
    );
  }


  renderQualidifedStats() {
    const { maxHeight } = this.state;
    const isAccount = this.isAccount();
    const isLoading = this.isLoading();
    const { progressStats } = this.props;

   

    const rows = [];
    each(STATS, (stat) => {
      const s = progressStats[stat.key];
      const { count } = s;
      if (count > 0) {
        rows.push(this.renderRow(stat.title, s, stat.key, stat.color));
      }
    });

    let body = null;
    let isEmpty = false;

    if (rows.length > 0) {
      body = rows;
    } else if (isLoading) {
      isEmpty = true;
      body = (
        <tr>
          <td>
            <p />
            <ProgressBar />
            <p />
          </td>
        </tr>
      );
    } else {
      isEmpty = true;
      body = (
        <tr>
          <td>
            <div className="alert alert-warning">No records found.</div>
          </td>
        </tr>
      );
    }


    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <div className="panel-title">

            <div className="clearfix">
              <div className="pull-left">Qualified, But Not Submitted <a href="" onClick={this.showQualifiedModal}><Fa className="text-active" name="info-circle" /></a></div>
              <div className="pull-right text-right" style={{ width: '100px' }}>
                {this.renderPercentage()}
                {' '}
                {this.renderDownloadButton()}
              </div>
            </div>

          </div>
        </div>
        <div className="panel-body">
          <ReactResizeDetector handleHeight handleWidth onResize={this.onResizeQualifiedContainer} />
          <div className="row">
            {!isEmpty &&
              <div className="col-xs-4">
                <div className={styles.graphWrapper}>
                  <div className={styles.graph}>{this.renderGraph()}</div>
                </div>
              </div>
            }
            <div className={isEmpty ? 'col-xs-12' : 'col-xs-8'}>
              <div style={{ minHeight: maxHeight }}>
                <table style={{ margin: 0 }} className="table table-condensed table-striped">
                  <tbody>
                    {body}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderOverviewModal() {
    return (
      <Modal key="modal" show={this.state.showOverviewModal} onHide={this.hideOverviewModal}>
        <Modal.Header closeButton>
          <h4>Dataset &amp; Submission Status for Feedback Request Progress</h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h5><strong>Dataset</strong></h5>
            <p>The opportunities or accounts displayed in this view are based on the current filters you have applied and the research type you have selected:</p>
            <ul>
              <li><strong>Decision</strong>: requesting feedback from buyers for sales opportunities as they close as wins, losses or no decisions (e.g., Win Loss Research)</li>
              <li><strong>Experience</strong>: requesting feedback from existing customers on their current experience with you and your solution (e.g., Customer Experience Research)</li>
            </ul>

            <h5><strong>Submission Status</strong></h5>
            <p>A submission status is calculated for each opportunity or account in the dataset based on the automation group selected. The automation group contains the trigger conditions, or the conditions required for an opportunity or account to be qualified, and the contact submit conditions for submitting contact(s) when an opportunity or account is qualified.</p>

            <p />
            <p>The following submissions statuses are calculated and displayed:</p>
            <ul>
              <li><strong>Qualified</strong>: The opportunity or account passes the trigger conditions for the selected automation group.</li>
              <li><strong>Submitted</strong>: At least one contact for the opportunity or account was submitted for feedback requests.</li>
              <li><strong>Excluded</strong>: At least one contact for the opportunity or account was submitted, but a user cancelled the feedback requests and excluded it from getting feedback. When a user excludes an opportunity/account, they must provide a reason for the exclusion.</li>
              <li><strong>Not Submitted</strong>: The opportunity or account passes the trigger conditions for the selected automation group, but some other conditions prevented the opportunity from being submitted for feedback.</li>
              <li><strong>Not Qualified</strong>: The opportunity or account does not pass the trigger conditions for the selected automation group.</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.hideOverviewModal}>Got It</Button>
        </Modal.Footer>
      </Modal>
    );
  }


  renderQualifiedModal() {
    const isAccount = this.isAccount();

    return (
      <Modal key="modal" show={this.state.showQualifiedModal} onHide={this.hideQualifiedModal}>
        <Modal.Header closeButton>
          <h4>Qualified, But Not Submitted</h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h5><strong>Not Submitted Status</strong></h5>
            <p>{isAccount ? 'Accounts' : 'Opportunities'} that are qualified, based on the automation group selected, but have not been submitted will fall into different categories:</p>
            <ul>
              <li><strong>No Qualified Contacts</strong>: TruSales was unable to find an eligible contact to submit for the opportunity. Check the Contact Submit Conditions for the selected automation group.</li>
              <li><strong>Prevented by Collector Settings</strong>: Most likely means the contact(s) for the opportunity have been submitted for feedback recently and the TruVoice Collector settings prevented them from being submitted. Check the TruVoice Collector settings for the selected automation group.</li>
              <li><strong>Failed Product Conditions</strong>: Based on the TruVoice Products settings at the time the opportunity was eligible to be submitted, the opportunity did not qualify. Check “TruVoice Products” settings.</li>
              <li><strong>Owner not Active</strong>: The opportunity&rsquo;s owner does not have an active CRM license.</li>
              <li><strong>Invalid Sender</strong>: TruVoice has not been authorized to send email on behalf of the assigned sender&rsquo;s email domain. Check the sender set for the opportunity and their email domain.</li>
              <li><strong>Invalid Account</strong>: Missing account info</li>
              <li><strong>Others</strong>: Qualified {isAccount ? 'accounts' : 'opportunities'} that TruSales cannot categorize are placed in this category. This usually occurs because the automation was not running at the time these {isAccount ? 'accounts' : 'opportunities'} became qualified.</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.hideQualifiedModal}>Got It</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { loadPercentage, progressStats, automation } = this.props;
    const { loading, loaded, error } = this.state;
    if (!loading && !loaded && error) {
      return (
        <div className="alert alert-danger">{error}</div>
      );
    }
    if (loadPercentage === 0) {
      return (
        <div>
          <p />
          <ProgressBar />
          <p />
        </div>
      );
    }
    const isEmpty = automation.is_empty === true;

    return (
      <div className="row">
        <div className={isEmpty ? 'col-xs-12' : 'col-md-4 col-lg-4'}>
          {this.renderOverviewStats()}
          {this.renderOverviewModal()}
        </div>
        {!isEmpty &&
          <div className="col-md-8 col-lg-8">
            {this.renderQualidifedStats()}
            {this.renderQualifiedModal()}
          </div>
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    loadPercentage: getProgressLoadPercentage(state),
    progressStats: getProgressStats(state),
  };
}


ProgressStats.propTypes = {
  dispatch: PropTypes.func.isRequired,
  resources: PropTypes.arrayOf(PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
  })).isRequired,
  automation: PropTypes.shape({
    _id: PropTypes.string,
    is_empty: PropTypes.bool,
  }).isRequired,
  progressStats: PropTypes.shape({
  }).isRequired,
  loadPercentage: PropTypes.number,
  showStats: PropTypes.func,
  dateAnchor: PropTypes.instanceOf(moment),
};
ProgressStats.defaultProps = {
  loadPercentage: 0,
  progressStats: {},
  showStats: () => {},
  dateAnchor: null,
};

ProgressStats.contextTypes = {
  addNotification: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};


export default connect(mapStateToProps)(ProgressStats);
